import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { Icon, IconType } from "../../../../common/icons/Icon";
import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";
import styles from "./InventoryTransferEmptyState.module.scss";

interface IEmptyStateProps {
  canCreate: boolean;
  onCreate: () => void;
}

export const InventoryTransferEmptyState = ({
  canCreate,
  onCreate,
}: IEmptyStateProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.icon}>
        <Icon
          type={IconType.Delivery}
          width="28px"
          height="28px"
          color="rgba(255, 255, 255, 0.5)"
        />
      </div>
      <h2 className={styles.title}>Все още нямате доставки</h2>
      <p className={styles.description}>
        Добавете първата си доставка, за да попълните складовата наличност.
      </p>
      <RenderWhen condition={canCreate}>
        <DefaultButton
          label="Нова доставка"
          design="default"
          onClick={onCreate}
        />
      </RenderWhen>
    </div>
  );
};
